import React from 'react';
import styled from 'styled-components';
import { withSiteData, withRouteData, Link } from 'react-static';
import em from 'polished/lib/helpers/em';

const AuxNavigationContainer = styled.div`
  font-size: 2.8em;
  line-height: ${em(4.8, 2.8)};
  margin-bottom: 1em;
  text-transform: uppercase;
  font-family: Flow-Poster-Bold;
  color: ${props => props.color};
  
  @media (max-width: 900px) {
    font-size: ${28/(900*0.01)}vw;
  }
  
  @media (max-width: 550px) {
    font-size: 2em;
    display: inline-block;
    
    a {
      display: block;
      margin-bottom: ${em(1, 2)};
      &:after {
        display: none !important;
      }
      
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  
  a {
    color: ${props => props.color};
    
    span {
      transition: color .2s ease-out;
    }
    
    &:${props => props.theme.hoverProperty} {
      span {
        color: ${props => props.highlightColor ? props.highlightColor : props.theme.highlightColor};
      }
    }
    
    &:after {
      content: ' / ';
      display: inline-block;
      padding: 0 .5em;
      font-family: Flow-Inverted;
    }
    
    &:last-child {
      &:after {
        display: none;
      }
    }
  }
  
  &:last-child {
    margin-bottom: 0;
  }
`;

interface Props {
  color?: string;
  highlightColor?: string;
  appLanguage?: IAppLanguage;
}

const AuxNavigation = ({
  color = 'black',
  highlightColor,
  appLanguage,
}: Props) => {
  return (
    <AuxNavigationContainer color={color} highlightColor={highlightColor}>
      <Link to={appLanguage.code === 'fi' ? '/yhteystiedot' : '/en/contact'}>
        <span>
          {appLanguage.code === 'fi' ? 'Yhteystiedot' : 'Contact'}
        </span>
      </Link>
      <Link to={appLanguage.code === 'fi' ? '/kumppanit' : '/en/partners'}>
        <span>
          {appLanguage.code === 'fi' ? 'Kumppanit' : 'Partners'}
        </span>
      </Link>
      <Link to={appLanguage.code === 'fi' ? '/media' : '/en/media'}>
        <span>
          Media
        </span>
      </Link>
      {/*<Link to={'/partners'}>
        <span>Archive</span>
      </Link>*/}
    </AuxNavigationContainer>
  )
};

export default withRouteData(AuxNavigation);


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/components/navigation/AuxNavigation.tsx